import { apiClient } from '@/utils/api'

export interface BracketTemplate {
  templateId: string
  leagueId: string
  groupId: string
  name: string
  description?: string
  displayOrder: number
  createdAt: string
  updatedAt: string
}

interface BracketTemplatesResponse {
  data: BracketTemplate[]
  meta: {
    total: number
  }
}

interface BracketTemplateResponse {
  data: BracketTemplate
}

export const bracketTemplateService = {
  async list(leagueId: string): Promise<BracketTemplate[]> {
    const response = await apiClient.authGet<BracketTemplatesResponse>(
      `/leagues/${leagueId}/bracket-templates`
    )
    return response.data
  },

  async get(leagueId: string, templateId: string): Promise<BracketTemplate> {
    const response = await apiClient.authGet<BracketTemplateResponse>(
      `/leagues/${leagueId}/bracket-templates/${templateId}`
    )
    return response.data
  },

  async create(
    leagueId: string,
    data: { name: string; description?: string; displayOrder?: number }
  ): Promise<BracketTemplate> {
    const response = await apiClient.authPost<BracketTemplateResponse>(
      `/leagues/${leagueId}/bracket-templates`,
      data
    )
    return response.data
  },

  async update(
    leagueId: string,
    templateId: string,
    data: { name?: string; description?: string; displayOrder?: number }
  ): Promise<BracketTemplate> {
    const response = await apiClient.authPut<BracketTemplateResponse>(
      `/leagues/${leagueId}/bracket-templates/${templateId}`,
      data
    )
    return response.data
  },

  async delete(leagueId: string, templateId: string): Promise<void> {
    await apiClient.authDelete(`/leagues/${leagueId}/bracket-templates/${templateId}`)
  },

  async reorder(leagueId: string, templateIds: string[]): Promise<BracketTemplate[]> {
    // Update displayOrder for each template based on its position in the array
    const updates = templateIds.map((templateId, index) =>
      this.update(leagueId, templateId, { displayOrder: index })
    )
    return Promise.all(updates)
  },

  async listPublic(leagueId: string): Promise<BracketTemplate[]> {
    const response = await apiClient.get<BracketTemplatesResponse>(
      `/leagues/${leagueId}/bracket-templates/public`
    )
    return response.data
  },
}
